import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/estampapadrepio',
    name: 'home',
    component: HomeView
  },
  {
    path: '/estampapadrepio/agradecimento-doacao',
    name: 'agradecimento-doacao',
    component: () => import('../views/AgradecimentoDoacaoView.vue')
  },
  {
    path: '/estampapadrepio/agradecimento-cadastro',
    name: 'agradecimento-cadastro',
    component: () => import('../views/AgradecimentoCadastroView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
